import _ from 'lodash';

import MediaConstants from './MediaConstants';

export function media(state = {}, action) {
    switch (action.type) {
        case MediaConstants.MEDIA_RECEIVED:
            const newState = {
                ...state
            };

            const media = action.payload;

            newState[media.id] = {
                id: media.id,
                accountId: media.account_id,
                filename: media.filename,
                path: media.path,
                label: media.label,
                type: media.type,
                size: media.size,
                thumbnails: media.thumbnails,
                createdAt: media.created_at,
                updatedAt: media.updated_at,
            };

            return newState;
            break;
        case MediaConstants.MEDIA_REMOVED:
            return _.filter(state, media => media.id !== action.payload.id );
            break;
        default:
            return state;
    }
}

export function uploads(state = {}, action) {
    const newState = {
        ...state
    };

    const upload = action.payload;

    switch(action.type) {
        case MediaConstants.UPLOAD_STARTED:
            return {
                ...state,
                [upload.id]: {
                    id: upload.id,
                    filename: upload.filename,
                    state: "pending",
                    percentage: 0
                }
            };

            break;
        case MediaConstants.UPLOAD_PROGRESS:
            return {
                ...state,
                [upload.id]: {
                    ...state[upload.id],
                    state: "uploading",
                    percentage: upload.progress
                }
            };

            break;
        case MediaConstants.UPLOAD_COMPLETE:
            return {
                ...state,
                [upload.id]: {
                    ...state[upload.id],
                    state: "done",
                    percentage: 100
                }
            };

            break;
        case MediaConstants.UPLOAD_ERROR:
            return {
                ...state,
                [upload.id]: {
                    ...state[upload.id],
                    state: "error",
                    percentage: 0
                }
            };

            break;
        default:
            return state;
    }
}
